module.exports = __webpack_public_path__ + "img/total.190f42bd.png";